import stateManager from './../state';

export const isEditMode = () => {
    const { isEditMode } = stateManager.store.getState();
    return isEditMode;
}
